/* eslint-disable import/prefer-default-export */
export const localLanguages = ['en', 'ja', 'ko']
